import { connectHits } from 'instantsearch.js/es/connectors';
import { autop } from '@wordpress/autop';
import collapsable from '../../collapsable';

// create the render function
const renderHits = (renderOptions) => {
    const { hits, widgetParams } = renderOptions;

    if (hits.length === 0) return;

    widgetParams.container.innerHTML = `
        ${hits.map((item) => `
            <div class="c-accordion js-collapsible">
                <h2 class="c-accordion_btn js-collapsible-btn"
                    data-open="false">
                    ${item.title}
                    <svg class="c-icon"><use xlink:href="#icon-chevron-down"></use></svg>
                </h2>
                <div class="c-accordion_body js-collapsible-content">
                    <div class="c-accordion_body-inner mx-auto prose">
                        ${autop(item.content)}
                    </div>
                </div>
            </div>
        `).join('')}
    `;

    collapsable();
};

// create the custom widget
const customHits = connectHits(renderHits);

export default customHits;
